import { render, staticRenderFns } from "./SewegePlantListForm.vue?vue&type=template&id=68d640c8&"
import script from "./SewegePlantListForm.vue?vue&type=script&lang=js&"
export * from "./SewegePlantListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports